import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { emailInitials } from '../../../team/emailInitials';
import { useWorkspaces } from '../../../workspaces/useWorkspaces';
import { creditMessages } from './creditMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the video credits; each part uses its own slice of it */
import styles from './Credits.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * Design release-kit e4 and n7: a team member at the credit limit sees whom to ask. Only the
 * workspace owner buys packs or upgrades (D11), so a member sees no buy button.
 */
const MemberOwnerNoteComponent: React.FC = () => {
  const intl = useIntl();
  const ownerEmail = useWorkspaces().active?.ownerEmail ?? null;

  return (
    <div className={styles.owner} data-testid="member-owner-note">
      {ownerEmail !== null && (
        <div className={styles.avatar} aria-hidden="true">
          {emailInitials(ownerEmail)}
        </div>
      )}
      <div data-clarity-mask="true">
        <b>{intl.formatMessage(creditMessages.ownerTitle)}</b>
        <div className={styles.muted}>
          {ownerEmail === null
            ? intl.formatMessage(creditMessages.ownerBodyNoEmail)
            : intl.formatMessage(creditMessages.ownerBody, { email: ownerEmail })}
        </div>
      </div>
    </div>
  );
};

export const MemberOwnerNote = TypedMemo(MemberOwnerNoteComponent);
